'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var app = {

	settings: {},

	vars: {},

	init: function init() {
		FastClick.attach(document.body);

		this.initGlobalExtensions();
		this.initLocalExtensions($('body'));
	},

	parse: function parse($context) {
		this.initLocalExtensions($context);
	},

	initGlobalExtensions: function initGlobalExtensions() {
		var t = this;
		for (var globalExt in t.globalExt) {
			if (!app.obj[globalExt]) {
				app.obj[globalExt] = new t.globalExt[globalExt]();
			}
		}
	},

	initLocalExtensions: function initLocalExtensions($context) {
		var t = this;
		for (var ext in t.ext) {
			var $els = $context.findOrSelf('.js-' + ext);
			$els.each(function () {
				var fn = new t.ext[ext]($(this));

				$(this).data('obj_' + ext, fn);

				if (app.obj[ext] === undefined) app.obj[ext] = [];
				if ($(this).data('objectName')) {
					app.obj[ext][$(this).data('objectName')] = fn;
				} else {
					app.obj[ext].push(fn);
				}
			});
		}
	},

	ext: {},
	globalExt: {},
	obj: {}
};

$(function () {
	app.init();
});

$.fn.findOrSelf = function (selector) {
	return this.find(selector).add(this.filter(selector));
};
app.globalExt['bazaar-voice'] = function () {
	var api = {};

	var init = function init() {
		if (typeof $BV !== 'undefined') {
			var productReviewArr = document.querySelectorAll('.js-product-review');
			if (!productReviewArr) return false;

			for (var i = 0; i < productReviewArr.length; i++) {
				initProductReview(productReviewArr[i].getAttribute('data-product-id'));
			}

			var productInlineArr = document.querySelectorAll('.js-product-inline');
			if (!productInlineArr) return false;

			var Productlst = [];
			for (var _i = 0; _i < productInlineArr.length; _i++) {
				Productlst.push(productInlineArr[_i]);
			}
			initProductInline(Productlst);
		}
	};

	var initProductReview = function initProductReview(productId) {
		$BV.configure('global', { productId: productId });

		$BV.ui('rr', 'show_reviews', {
			doShowContent: function doShowContent() {
				// If the container is hidden (such as behind a tab), put code here to make it visible
				//(open the tab).
			}
		});
	};

	var initProductInline = function initProductInline(productsList) {
		if (!Object.keys(productsList).length) {
			return;
		}

		var productIds = {};
		for (var i = 0; i < productsList.length; i++) {
			productIds[productsList[i].getAttribute('data-product-id')] = {
				url: productsList[i].getAttribute('data-bv-redirect-url'),
				containerId: productsList[i].getAttribute('data-product-id')
			};
		}

		var data = {
			productIds: productIds
		};

		$BV.ui('rr', 'inline_ratings', data);
	};

	init();
	return api;
};

app.globalExt['global-structure'] = function () {
	var api = {};

	var init = function init() {};

	init();
	return api;
};

app.globalExt['lazy'] = function () {
	var api = {};
	var lazyImages;
	var active = false;

	var init = function init() {
		addLazyloadingAction();
	};

	var initImages = function initImages() {
		lazyImages.map(function (img) {
			var width = img.getAttribute('width');
			var height = img.getAttribute('height');
			if (width && height) {
				img.style.paddingTop = height / width * 100 + "%";
			}
			img.classList.add('lazyloading');
		});
	};

	var addLazyloadingAction = function addLazyloadingAction() {
		lazyImages = [].concat(_toConsumableArray(document.querySelectorAll(".js-lazy")));

		initImages();
		lazyLoad();

		document.addEventListener("scroll", lazyLoad);
		window.addEventListener("resize", lazyLoad);
		window.addEventListener("orientationchange", lazyLoad);
	};

	var lazyLoad = function lazyLoad() {
		// if (active) return true;
		// return true;
		setTimeout(function () {
			lazyImages.map(function (lazyImage) {
				if (lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) {
					lazyImage.src = lazyImage.dataset.src;
					lazyImage.classList.remove("js-lazy");
					lazyImage.classList.add("is-loaded");
					lazyImage.style.paddingTop = "0";

					lazyImages = lazyImages.filter(function (image) {
						return image !== lazyImage;
					});

					if (lazyImages.length === 0) {
						document.removeEventListener("scroll", lazyLoad);
						window.removeEventListener("resize", lazyLoad);
						window.removeEventListener("orientationchange", lazyLoad);
					}
				}
			});
		}, 100);
	};

	init();
	return api;
};

app.globalExt['matchheight'] = function () {
	var api = {};

	var init = function init() {
		initMatchheight();

		$(document).on('dom-changed.matchheight', function () {
			initMatchheight();
		});
	};

	var initMatchheight = function initMatchheight() {
		$('.js-matchheight').matchHeight();

		$('.js-matchheight').off('lazy-loaded.matchheight').on('lazy-loaded.matchheight', function () {
			initMatchheight();
		});

		$('.js-matchheight img').off('load.matchheight').on('load.matchheight', function () {
			initMatchheight();
		});
	};

	init();
	return api;
};

app.globalExt['placeholder'] = function () {
	var api = {};

	var init = function init() {
		$('input, textarea').placeholder();
	};

	init();
	return api;
};

app.ext['accordeon'] = function ($element) {
	var api = {};
	var $rows = $element.find('.js-accordeon-row');

	var init = function init() {
		$rows.filter('.is-open').find('.js-accordeon-body').css('display', 'block');

		addListeners();
	};

	var addListeners = function addListeners() {
		$rows.on('click', '.js-accordeon-title', function (e) {
			e.preventDefault();
			toggle($(e.delegateTarget));
		});
	};

	var toggle = function toggle($row) {
		if ($row.hasClass('is-open')) {
			close($row);
		} else {
			open($row);
		}
	};

	var open = function open($row) {
		if ($row.hasClass('is-open')) {
			return;
		}

		$rows.filter('.is-open').each(function () {
			close($(this));
		});

		$row.find('.js-accordeon-body').stop().slideDown(400);
		$row.addClass('is-open');
	};

	var close = function close($row) {
		if (!$row.hasClass('is-open')) {
			return;
		}

		$row.find('.js-accordeon-body').stop().slideUp(400);
		$row.removeClass('is-open');
	};

	init();
	return api;
};

app.ext['contactform'] = function ($element) {
	var api = {};
	var $inputs = [];
	var init = function init() {
		$inputs = $element.find('input:not(:hidden), textarea');
		$inputs.on('change', verify);
		setTimeout(verify, 2000);
	};

	var verify = function verify() {
		var validate = true;
		var $submitBtn = $element.find('.form__input-submit');
		$inputs.each(function (index, item) {
			if (item.value == '') {
				validate = false;
			}
		});
		$submitBtn.prop('disabled', !validate);
	};

	init();
	return api;
};

app.ext['cookie-header'] = function ($element) {
	var api = {};

	var $html = $('html');
	var $site = $('.js-site');

	var init = function init() {
		addListeners();
		$html.addClass('has-cookies-not-accepted');

		if (checkVisibility()) {
			addListeners();
			checkPadding();
		}
	};

	var addListeners = function addListeners() {
		$element.on('click', '.js-cookie-header-accept', function (e) {
			e.preventDefault();

			Cookies.set('cookie-agreed', '2', { expires: 365 });

			$element.velocity({
				translateY: '100%',
				opacity: 0
			}, {
				duration: 300,
				easing: 'easeOutQuart',
				complete: function complete() {
					$(this).remove();
					checkPadding();
				}
			});

			$site.velocity({
				'margin-bottom': 0
			}, {
				duration: 300,
				easing: 'easeOutQuart'
			});

			$html.removeClass('has-cookies-not-accepted');
		});

		$(window).on('resize load', _.debounce(function () {
			checkPadding();
		}, 200));
	};

	var checkVisibility = function checkVisibility() {
		if (hasCookieAccepted()) {
			$element.remove();
			$html.removeClass('has-cookies-not-accepted');
			return false;
		} else {
			$element.velocity({
				translateY: ['0%', '100%']
			}, {
				duration: 500,
				easing: 'easeOutQuart'
			});
			return true;
		}
	};

	var hasCookieAccepted = function hasCookieAccepted() {
		return Cookies.get('cookie-agreed') == 2;
	};

	var checkPadding = function checkPadding() {
		var height = $element.outerHeight() || '';

		if (hasCookieAccepted()) {
			height = '';
		}

		$site.css('margin-bottom', height);
	};

	init();
	return api;
};

app.ext['flipcounter'] = function ($element) {
	var api = {};

	var $month_counter = $('.js-flipcounter-month');
	var $year_counter = $('.js-flipcounter-year');

	var month = parseInt($month_counter.data('month'));
	var year = parseInt($year_counter.data('year'));

	var init = function init() {
		var i = 0;

		var month_clock = $month_counter.FlipClock(0, {
			clockFace: 'Counter'
		});

		var year_clock = $year_counter.FlipClock(year, {
			clockFace: 'Counter'
		});

		setTimeout(function () {
			var inter = setInterval(function () {
				i++;
				month_clock.increment();

				if (i >= month) {
					clearInterval(inter);
				}
			}, 300);
		});
	};

	init();
	return api;
};

app.ext['footer'] = function ($element) {
	var api = {};

	var init = function init() {
		$element.on('click', '.js-footer-scroll-up', function (e) {
			e.preventDefault();

			$('body').velocity('scroll', {
				offset: 0,
				duration: 800,
				easing: 'easeInOutQuart'
			});
		});
	};

	init();
	return api;
};

app.ext['header'] = function ($element) {
	var api = {};

	var $navTrigger = $element.find('.js-header-nav-trigger');
	var $searchTrigger = $element.find('.js-header-search-trigger');
	var $searchContainer = $element.find('.js-header-search-container');

	var init = function init() {
		addListeners();
	};

	var addListeners = function addListeners() {
		$navTrigger.on('click', function (e) {
			e.preventDefault();

			toggleNav();
		});

		$searchTrigger.on('click', function (e) {
			e.preventDefault();

			toggleSearch();
		});
	};

	var toggleNav = function toggleNav() {
		if ($navTrigger.hasClass('is-active')) {
			closeNav();
		} else {
			openNav();
		}
	};

	var openNav = function openNav() {
		$navTrigger.addClass('is-active');
		$(document).trigger('open-mobile-navigation');
	};

	var closeNav = function closeNav() {
		$navTrigger.removeClass('is-active');
		$(document).trigger('close-mobile-navigation');
	};

	var toggleSearch = function toggleSearch() {
		if ($searchTrigger.hasClass('is-active')) {
			closeSearch();
		} else {
			openSearch();
		}
	};

	var openSearch = function openSearch() {
		$searchTrigger.addClass('is-active');

		$searchContainer.stop().slideDown({
			duration: 400,
			easing: 'easeOutQuart'
		});
	};

	var closeSearch = function closeSearch() {
		$searchTrigger.removeClass('is-active');

		$searchContainer.stop().slideUp({
			duration: 400,
			easing: 'easeOutQuart'
		});
	};

	init();
	return api;
};

app.ext['hero-slider'] = function ($element) {
	var api = {};

	var $swiper = $element.find('.js-hero-slider-swiper');

	var init = function init() {
		initSwiper();
	};

	var initSwiper = function initSwiper() {
		var $slider = $swiper.find('.swiper-wrapper');
		$element.addClass('is-loaded');
		$slider.slick({
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			prevArrow: $swiper.find('.js-hero-slider-prev'),
			nextArrow: $swiper.find('.js-hero-slider-next')
		});
	};

	init();
	return api;
};

app.ext['local-structure'] = function ($element) {
	var api = {};

	var init = function init() {};

	init();
	return api;
};

app.ext['navigation'] = function ($element) {
	var api = {};

	var $subToggles = $element.find('.js-navigation-sub-toggle');
	var $subs = $element.find('.js-navigation-sub');
	var $mobileSubToggles = $element.find('.js-navigation-mobile-sub-toggle');
	var $mobileSubs = $element.find('.js-navigation-mobile-sub');

	var $site = $('.js-site');
	var $siteHeader = $('.js-site-header');
	var $html = $('html');

	var init = function init() {
		enquire.register('screen and (min-width: 1180px)', {
			match: function match() {
				resetMobile();
				initDesktop();
			}
		});
		enquire.register('screen and (max-width: 1179px)', {
			match: function match() {
				resetDesktop();
				initMobile();
			}
		});
	};

	var initDesktop = function initDesktop() {
		addDesktopListeners();
	};

	var resetDesktop = function resetDesktop() {
		removeDesktopListeners();
		$subToggles.removeClass('is-open');
		$subs.removeClass('is-open');
	};

	var initMobile = function initMobile() {
		$element.insertAfter($site);
		$mobileSubs.hide();
		addMobileListeners();
	};

	var resetMobile = function resetMobile() {
		closeMobileNavigation();
		$element.appendTo($siteHeader);
		removeMobileListeners();
		$mobileSubs.css('display', '');
		$mobileSubToggles.removeClass('is-open');
		$mobileSubs.removeClass('is-open').stop().css({
			height: '',
			padding: '',
			margin: '',
			border: '',
			overflow: '',
			display: ''
		});
	};

	var addDesktopListeners = function addDesktopListeners() {
		$subToggles.on('mouseenter.navigation', function (e) {
			var $toggle = $(e.currentTarget);
			var $sub = $toggle.find('.js-navigation-sub');

			$toggle.addClass('is-open');
			$sub.addClass('is-open');
		});

		$subToggles.on('mouseleave.navigation', function (e) {
			var $toggle = $(e.currentTarget);
			var $sub = $toggle.find('.js-navigation-sub');

			$toggle.removeClass('is-open');
			$sub.removeClass('is-open');
		});
	};

	var removeDesktopListeners = function removeDesktopListeners() {
		$subToggles.off('mouseenter.navigation');
		$subToggles.off('mouseleave.navigation');
	};

	var addMobileListeners = function addMobileListeners() {
		$mobileSubToggles.on('click.navigation', function (e) {
			e.preventDefault();

			var $toggle = $(e.currentTarget);

			if ($toggle.hasClass('is-open')) {
				closeMobileSub($toggle);
			} else {
				openMobileSub($toggle);
			}
		});

		$(document).on('open-mobile-navigation.navigation', function () {
			openMobileNavigation();
		});

		$(document).on('close-mobile-navigation.navigation', function () {
			closeMobileNavigation();
		});
	};

	var removeMobileListeners = function removeMobileListeners() {
		$mobileSubToggles.off('click.navigation');
		$(document).off('open-mobile-navigation.navigation');
		$(document).off('close-mobile-navigation.navigation');
	};

	var openMobileNavigation = function openMobileNavigation() {
		$html.addClass('is-mobile-navigation-open');
	};

	var closeMobileNavigation = function closeMobileNavigation() {
		$html.removeClass('is-mobile-navigation-open');

		$mobileSubToggles.each(function () {
			var $toggle = $(this);
			closeMobileSub($toggle);
		});
	};

	var openMobileSub = function openMobileSub($toggle) {
		if ($toggle.hasClass('is-open')) {
			return;
		}

		var $sub = $toggle.next('.js-navigation-mobile-sub');

		$toggle.addClass('is-open');
		$sub.addClass('is-open');
		$sub.stop().slideDown();

		// close siblings
		$mobileSubToggles.each(function () {
			var $otherToggle = $(this);
			var $otherSub = $otherToggle.next('.js-navigation-mobile-sub');

			if ($otherToggle[0] !== $toggle[0] && !$otherSub.find($toggle).length) {
				closeMobileSub($otherToggle);
			}
		});
	};

	var closeMobileSub = function closeMobileSub($toggle) {
		if (!$toggle.hasClass('is-open')) {
			return;
		}

		var $sub = $toggle.next('.js-navigation-mobile-sub');

		$toggle.removeClass('is-open');
		$sub.removeClass('is-open');
		$sub.stop().slideUp();

		// close children
		$sub.find('.js-navigation-mobile-sub-toggle').each(function () {
			closeMobileSub($(this));
		});
	};

	init();
	return api;
};

app.ext['related-products'] = function ($element) {
	var api = {};

	var $swiper = $element.find('.js-related-products-swiper');

	var init = function init() {
		initSwiper();
	};

	var initSwiper = function initSwiper() {

		var $slider = $swiper.find('.swiper-wrapper');
		$slider.slick({
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 4,
			centerMode: false,
			prevArrow: $swiper.find('.js-related-products-prev'),
			nextArrow: $swiper.find('.js-related-products-next'),
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		});
	};

	init();
	return api;
};

app.ext['search'] = function ($element) {
	var api = {};

	var init = function init() {
		var $form = $element;
		var $checkBox = $element.find("input[type='checkbox']");
		$checkBox.each(function (index, item) {
			var $item = $(item);
			$item.on('change', function () {
				$form.submit();
			});
		});
	};

	init();
	return api;
};

app.ext['slider'] = function ($element) {
	var api = {};

	var $swiper = $element.find('.js-slider-swiper');

	var init = function init() {
		initSwiper();
	};

	var initSwiper = function initSwiper() {
		var $slider = $swiper.find('.swiper-wrapper');
		$slider.slick({
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			prevArrow: $swiper.find('.js-slider-prev'),
			nextArrow: $swiper.find('.js-slider-next')
		});
	};

	init();
	return api;
};

app.ext['storelocator'] = function ($element) {
	var api = {};
	var map,
	    google,
	    currentLocation,
	    currentLocationMarker,
	    markers = [],
	    defaultDistance = -1,
	    itemsPerPage = 20,
	    currentPage = 1,
	    translation = null;

	var init = function init() {
		window.initialize = initializeGmap;
		loadScript();

		setPage($element.data('page'));

		translation = JSON.parse(document.querySelector('.js-storelocator-list-wrapper').dataset.translation);
	};

	var getPharmacies = function getPharmacies() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

		$.ajax({
			method: 'get',
			url: $element.data('api'),
			data: {
				page: page,
				lat: currentLocation ? currentLocation.lat : null,
				lng: currentLocation ? currentLocation.lng : null,
				maxDistance: defaultDistance > 0 ? defaultDistance : 100
			},
			success: function success(response) {
				var places = response.data;
				setPagination(parseInt(response.page), parseInt(response.totalPages));
				refreshList(places);
			},
			error: function error() {
				console.error(arguments);
			}
		});
	};

	/**
  * calls loading gmap script
  * @return {[type]} [description]
  */
	var loadScript = function loadScript() {
		var apiKey = $element.data('key'),
		    script = document.createElement('script');

		script.type = 'text/javascript';
		script.src = '//maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=initialize';
		document.body.appendChild(script);
	};

	/**
  * adds events to search form
  */
	var addEvents = function addEvents() {
		$element.find('.js-storelocator-form').on('submit', function (e) {
			e.preventDefault();
			var location = $element.find('.js-storelocator-place').val(),
			    distance = $element.find('.js-storelocator-distance').val();

			defaultDistance = distance == parseInt(distance, 10) ? distance : defaultDistance;
			if (location.length > 3) {
				setLocation(location);
			}
		});

		$element.on('click', '.js-pagination-link', function (el) {
			el.preventDefault();
			var page = $(this).data('page');
			setPage(page);
		});
	};

	/**
  * callback for googlemap api js
  * it initializes all functionalities one gmap is loaded
  */
	var initializeGmap = function initializeGmap() {
		google = window.google;
		currentLocation = new google.maps.LatLng($element[0].dataset.lat, $element[0].dataset.lng); // default fallback location to Madrid

		var mapOptions = {
			zoom: 7,
			center: currentLocation,
			scrollwheel: false,
			navigationControl: false,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: false
		};
		map = new google.maps.Map(document.getElementById('googleMap'), mapOptions);

		$element.find('.js-storelocator-spinner').velocity('fadeOut', {
			duration: 300
		});

		addEvents(); // add events for form
		geolocate(); // run browser geolocation
	};

	/**
  * add all markers for the map and center to them
  */
	var addMarkersToMap = function addMarkersToMap(places) {
		var bounds = new google.maps.LatLngBounds();
		var offset = (currentPage - 1) * itemsPerPage;

		for (var i = 0; i < places.length; i++) {
			if (places[i]) {
				var marker = addMarker(places[i]);
				bounds.extend(marker.position);
				markers.push(marker);
			}
		}

		if (markers.length > 1) {
			map.fitBounds(bounds); // center to all markers
		} else if (markers.length === 1) {
			map.setCenter(markers[0].getPosition()); // center to the marker
			map.setZoom(10);
		} else {
			map.setCenter(currentLocation); // center to the current location if no marker
			map.setZoom(10);
		}
	};

	/**
  * delete all markers from the map
  */
	var deleteMarkersFromMap = function deleteMarkersFromMap() {
		for (var i = 0; i < markers.length; i++) {
			markers[i].setMap(null);
		}
		markers = [];
	};

	/**
  * adds marker for the current place
  * @param  {Object} place 			object of the place
  * @return {google.maps.Marker}     googlemap Marker object
  */
	var addMarker = function addMarker(place) {
		var location = new google.maps.LatLng(place.map.lat, place.map.lng),
		    infowindow = createInfowindow(place),
		    image = $element.data('icon'),
		    marker = new google.maps.Marker({
			position: location,
			title: place.name,
			icon: image,
			map: map
		});
		marker.addListener('click', function () {
			infowindow.open(map, marker);
		});

		return marker;
	};

	/**
  * creates googlemap infowindow for the current place(marker)
  * @param  {Object} place 					object of the place
  * @return {google.maps.InfoWindow}       	object of the infowindow
  */
	var createInfowindow = function createInfowindow(place) {
		return new google.maps.InfoWindow({
			content: '\n\t\t\t\t<div class="infowindow">\n\t\t\t\t\t<p class="infowindow__text">\n\t\t\t\t\t\t' + place.name + '<br>\n\t\t\t\t\t\t' + place.street + '<br>\n\t\t\t\t\t\t' + place.zip + '\n\t\t\t\t\t\t' + place.city + '\n\t\t\t\t\t\t' + (place.state ? '(' + place.state + ')' : '') + '\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="infowindow__text">' + (isNaN(place.distance) ? '-' : place.distance) + 'km</p>\n\t\t\t\t\t<p class="infowindow__text">TEL: <a href="tel:' + place.phone + '">' + place.phone + '</a></p>\n\t\t\t\t</div>'
		});
	};

	/**
  * browser geolocation, call centerToLocation as a callback
  */
	var geolocate = function geolocate() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function (position) {
				var location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
				centerToLocation(location);
			});
		}
	};

	/**
  * set the current location from the string address
  * @param  {string} LocationString address
  */
	var setLocation = function setLocation(LocationString) {
		if (LocationString.length < 4) {
			return false;
		}
		var geocoder = new google.maps.Geocoder();
		geocoder.geocode({ 'address': LocationString }, function (results, status) {
			if (status === 'OK') {
				centerToLocation(results[0].geometry.location);
			} else {
				console.error('Geocode was not successful for the following reason: ' + status);
			}
		});
	};

	/**
  * set the current location, if the marker already exists, change its location
  * @param  {google.maps.LatLng} location google type location
  */
	var centerToLocation = function centerToLocation(location) {
		currentLocation = location;
		getPharmacies();
		if (currentLocationMarker) {
			currentLocationMarker.setPosition(currentLocation);
		} else {
			currentLocationMarker = new google.maps.Marker({
				position: currentLocation,
				map: map
			});
		}
	};

	/**
  * refresh list of places
  */
	var refreshList = function refreshList(places) {
		deleteMarkersFromMap();
		addMarkersToMap(places);
		createListHtml(places);
	};

	/**
  * create html of the list of places
  */
	var createListHtml = function createListHtml(places) {
		var content = '',
		    $list = $element.find('.js-storelocator-list');
		for (var i = 0; i < places.length; i++) {
			content += createPlaceElement(places[i]);
		}
		$list.html(content);
	};

	/**
  * set page of list
  * @param  {[type]} page [description]
  * @return {[type]}      [description]
  */
	var setPage = function setPage(page) {
		currentPage = parseInt(page, 10);
		getPharmacies(currentPage);
	};

	/**
  * create elements for a place
  * @param  {Object} place place object
  * @return {string}       html of the current place
  */
	var createPlaceElement = function createPlaceElement(place) {
		var tel = place.phone ? 'TEL: <a href="tel:' + place.phone + '">' + place.phone + '</a>' : '';
		return '\n\t\t<li class="storelocator-list__item js-storelocator-item" id="place-' + place.id + '">\n\t\t\t<div class="storelocator-item">\n\t\t\t\t<div class="storelocator-item__content">\n\t\t\t\t\t<p class="storelocator-item__text storelocator-item__text--name">\n\t\t\t\t\t\t' + place.name + '\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="storelocator-item__text storelocator-item__text--address">\n\t\t\t\t\t\t' + place.street + '<br>\n\t\t\t\t\t\t' + place.zip + '\n\t\t\t\t\t\t' + place.city + '\n\t\t\t\t\t\t' + (place.state ? '(' + place.state + ')' : '') + '\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="storelocator-item__text storelocator-item__text--phone">\n\t\t\t\t\t\t\t' + tel + '\n\t\t\t\t\t\t&nbsp;\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="storelocator-item__text storelocator-item__text--distance js-place-distance">\n\t\t\t\t\t\t' + (isNaN(place.distance) ? '-' : place.distance) + '\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</li>\n\t\t';
	};

	/**
  * add pagination to the list
  */
	var setPagination = function setPagination(currentPage, totalPages) {
		var $pagination = $element.find('.js-storelocator-pagination');
		$pagination.html(createPagination(currentPage, totalPages));
	};

	/**
  * create html element of pagination
  * @return {string} html of the pagination
  */
	var createPagination = function createPagination(currentPage, totalPages) {
		var pageLinks = '';
		// var totalPages = Math.ceil(places.length / itemsPerPage);
		var firstPage = Math.max(currentPage - 4, 1);
		var lastPage = Math.min(firstPage + 8, totalPages);

		if (totalPages === 1) {
			return '';
		}

		if (totalPages > 1) {

			if (firstPage !== 1) {
				pageLinks += '<li class="pagination__list-item">\u2026</li>';
			}

			for (var i = firstPage; i < lastPage + 1; i++) {
				var linkCls = currentPage === i ? 'active' : '';
				pageLinks += '\n\t\t\t\t\t<li class="pagination__list-item">\n\t\t\t\t\t\t<button class="pagination__list-link pagination__list-link--' + linkCls + ' js-pagination-link" data-page="' + i + '">' + i + '</button>\n\t\t\t\t\t</li>\n\t\t\t\t';
			}

			if (lastPage !== totalPages) {
				pageLinks += '<li class="pagination__list-item">\u2026</li>';
			}
		}

		var prevLinkCls = currentPage === 1 ? 'invisible' : '';
		var prevPageNr = currentPage > 1 ? currentPage - 1 : 1;
		var prevLink = '\n\t\t\t<li class="pagination__list-item">\n\t\t\t\t<button class="pagination__list-link pagination__list-link--prev pagination__list-link--' + prevLinkCls + ' js-pagination-link" data-page="' + prevPageNr + '"><span>\u2039 ' + translation.prev + '</span></button>\n\t\t\t</li>\n\t\t';
		var firstLink = '\n\t\t\t<li class="pagination__list-item">\n\t\t\t\t<button class="pagination__list-link pagination__list-link--fist pagination__list-link--' + prevLinkCls + ' js-pagination-link" data-page="1"><span>\u2039\u2039 ' + translation.first + '</span></button>\n\t\t\t</li>\n\t\t';
		var nextLinkCls = currentPage === totalPages ? 'invisible' : '';
		var nextPageNr = currentPage < totalPages ? currentPage + 1 : totalPages;
		var nextLink = '\n\t\t\t<li class="pagination__list-item">\n\t\t\t\t<button class="pagination__list-link pagination__list-link--next pagination__list-link--' + nextLinkCls + ' js-pagination-link" data-page="' + nextPageNr + '"><span>' + translation.next + ' \u203A</span></button>\n\t\t\t</li>\n\t\t';
		var lastLink = '\n\t\t\t<li class="pagination__list-item">\n\t\t\t\t<button class="pagination__list-link pagination__list-link--next pagination__list-link--' + nextLinkCls + ' js-pagination-link" data-page="' + totalPages + '"><span>' + translation.last + ' \u203A\u203A</span></button>\n\t\t\t</li>\n\t\t';

		return '\n\t\t<div class="pagination">\n\n\t\t\t<ul class="pagination__list">\n\n\t\t\t\t' + firstLink + '\n\t\t\t\t' + prevLink + '\n\t\t\t\t' + pageLinks + '\n\t\t\t\t' + nextLink + '\n\t\t\t\t' + lastLink + '\n\n\t\t\t</ul>\n\t\t</div>\n\n\t\t';
	};

	init();
	return api;
};

app.ext['trigger-review'] = function ($element) {
	var api = {};

	var init = function init() {

		$element.on('click', function (e) {
			triggerReview(e);
		});
	};

	var triggerReview = function triggerReview(e) {

		e.preventDefault();

		$('.yotpo .write-review-wrapper').first().slideDown(250);

		scrollToReview();
	};

	init();
	return api;
};

$(document).ready(function () {

	$(document).on('click', function (e) {
		var $t = $(e.target);
		if ($t.hasClass('write-review-button') || $t.parents('.write-review-button').length > 0) {
			scrollToReview();
		}
	});
});

var scrollToReview = function scrollToReview() {

	var $review_wrapper = $('.write-review-wrapper');
	$([document.documentElement, document.body]).animate({
		scrollTop: $review_wrapper.offset().top
	}, 800);
};
app.ext['video'] = function ($element) {
	var api = {};
	var player;

	var init = function init() {
		var $tgl = $element.find('.js-video-tgl');
		addOpenAction($tgl);

		window.onYouTubeIframeAPIReady = createYoutubeReadyEvent;
		window.stop = stopVideo;

		document.body.addEventListener('youtubeApiReady', loadPlayer);
	};

	var createYoutubeReadyEvent = function createYoutubeReadyEvent() {
		var event = new Event('youtubeApiReady');
		document.body.dispatchEvent(event);
	};

	var loadPlayer = function loadPlayer() {
		var $player = $element.find('.js-video-player');
		player = new YT.Player($player[0], {});
	};

	var stopVideo = function stopVideo() {
		if (player) player.stopVideo();
	};

	var playVideo = function playVideo() {
		if (player) player.playVideo();
	};

	var addOpenAction = function addOpenAction($el) {
		$el.on('click', function () {
			$element.addClass('is-open');
			setTimeout(function () {
				addCloseAction($element);
				playVideo();
			}, 300);
		});
	};

	var removeCloseAction = function removeCloseAction($el) {
		$el.off('click');
	};

	var addCloseAction = function addCloseAction($el) {
		$el.on('click', function () {
			if ($(this).hasClass('is-open')) {
				stopVideo();
				$element.removeClass('is-open');
				removeCloseAction($el);
			}
		});
	};

	init();
	return api;
};

app.ext['yotpo'] = function ($element) {
	var api = {};

	var init = function init() {

		var interval = setInterval(function () {

			if ($element.find('.stars-wrapper').length > 0) {
				clearInterval(interval);
				var $stars = $element.find('.stars-wrapper').first().clone();
				$stars.find('.yotpo-icon').each(function () {
					$(this).removeClass('review-star');
				});

				$element.find('.yotpo-single-choice-select').each(function () {
					var $this = $(this);

					if ($this.find('option').eq(1).text().charCodeAt() == 9733) {
						if ($this.find('.stars-wrapper').length < 1) {
							$this.parent().append($stars.clone());
							$this.hide(0);
						}
					}
				});
			}

			$('.yotpo-single-choice-field .yotpo-icon').mouseover(function () {
				var $this = $(this);
				$this.removeClass('yotpo-icon-empty-star');
				$this.prevAll().removeClass('yotpo-icon-empty-star');
				$this.addClass('yotpo-icon-star');
				$this.prevAll().addClass('yotpo-icon-star');
			}).mouseout(function () {
				var $this = $(this);
				$this.parent().find('.yotpo-icon').removeClass('yotpo-icon-star');
				$this.parent().find('.yotpo-icon').addClass('yotpo-icon-empty-star');
			}).click(function () {
				var $this = $(this);
				var score = $this.data('score');

				$this.parent().find('.active').removeClass('active');
				$this.addClass('yotpo-icon-star active').removeClass('yotpo-icon-empty-star');
				$this.prevAll().addClass('yotpo-icon-star active').removeClass('yotpo-icon-empty-star');
				$this.nextAll().addClass('yotpo-icon-empty-star').removeClass('yotpo-icon-star');

				$this.parents('.yotpo-single-choice-field').find('select option:eq(' + score + ')').prop('selected', true);
			});

			$('.yotpo-single-choice-field .stars-wrapper').mouseleave(function () {
				var $this = $(this);
				$this.find('.yotpo-icon.active').removeClass('yotpo-icon-empty-star');
				$this.find('.yotpo-icon.active').addClass('yotpo-icon-star');
			});
		}, 1000);
	};

	init();
	return api;
};